export class ClientAgreementTemplateBO {
    iD: string = "00000000-0000-0000-0000-000000000000";
    documentLid: string | null;
    documentName: string;
    agencyid: string;
    documentValue: ClientAgreementTemplateMergedBO;
}

export class ClientAgreementTemplateMergedBO {
    release_of_InformationTemplateBO: Release_of_InformationTemplateBO = new Release_of_InformationTemplateBO();
    employerOrPayerAppointmentOfAgentTemplateBO: EmployerOrPayerAppointmentOfAgentTemplateBO = new EmployerOrPayerAppointmentOfAgentTemplateBO();
    application_Employer_Identification_NumberTemplateBO: Application_Employer_Identification_NumberTemplateBO = new Application_Employer_Identification_NumberTemplateBO();
    participantAgreementTemplateBO: ParticipantAgreementTemplateBO = new ParticipantAgreementTemplateBO();
    individual_Sole_Proprietor_OfAttornyTemplateBO: Individual_Sole_Proprietor_OfAttornyTemplateBO = new Individual_Sole_Proprietor_OfAttornyTemplateBO();
}

export class Release_of_InformationTemplateBO {
    others: string;
    authorizeBestCare: any;
}

export class EmployerOrPayerAppointmentOfAgentTemplateBO {
    agentEmployerIndentificationNumber: string;
    agenctsName: string;
    agentTradeName: string;
    agentStreet: string;
    agentSuiteOrRoomNumber: string;
    agentCity: string;
    agentState: string;
    agentZip: string;
    agenct_ifyou_are_home_care_service_recipient: string;
    agentSign: string;
    agentSignDate: string | null;
    agentTypeName: string;
    titleName: string;
    agentDayTimePhone: string;
    futaForAll: boolean;
    futaForSome: boolean;
    employersQuarterlyFederalTaxForAll: boolean;
    employersQuarterlyFederalTaxForSome: boolean;
    employersAnnualFederalTaxReturnForAll: boolean;
    employersAnnualFederalTaxReturnForSome: boolean;
    employersAnnualFederalIncomeReturnForAll: boolean;
    employersAnnualFederalIncomeReturnForSome: boolean;
    annualReturnofWithheldFederalIncomeTaxForAll: boolean;
    annualReturnofWithheldFederalIncomeTaxForSome: boolean;
    employersAnnualRailroadRetirementTaxReturnForAll: boolean;
    employersAnnualRailroadRetirementTaxReturnForSome: boolean;
    employeeRepresentativesQuarterlyRailroadTaxReturnForAll: boolean;
    employeeRepresentativesQuarterlyRailroadTaxReturnForSome: boolean;
    ifyou_are_home_care_service_recipient: boolean;
    appointorRevoke: string | null;
    typeName: string;
    dayTimePhone: string;
}

export class Application_Employer_Identification_NumberTemplateBO {
    agencyCity_state_zipIdifferent: string;
    agencyCounty: string;
    nameofResponsibleParty: string;
    ssn: string;
    isapplicationLlc: any;
    ifYesnumberofLlcMembers: string;
    isllc_Organized_UnitedStates: any;
    solepropritor_Ssn: string;
    corporationNumber: string;
    otherNonProfitOrgText: string;
    other_9aText: string;
    estate_Ssn: string;
    planAdministrator_Tin: string;
    trust_Tin: string;
    genIfAny: string;
    state_9b: string;
    foreignCountry: string;
    startedNewbusinessSpecifyType: string;
    backingPurposeSpecifyType: string;
    changedTypeOrgType: string;
    createdTrustSpecifyType: string;
    createdPensionPlanSpecifyType: string;
    hiredEmployees: boolean;
    compliance: boolean;
    other_10: boolean;
    other_10_specify: string;
    dateofBusinessStarted: string | null;
    closingMonth: string;
    no_of_employees_Agriculture: string;
    no_of_employees_HouseHold: string;
    no_of_employees_other: string;
    file_Form_941_every_quarter: string;
    first_date_wages_Annuities_were_paid: string | null;
    othertext_16: string;
    purchaseedGoingBusinesstext: string;
    agencyCity_state_zipIdifferent1: string;
    indicate_Principle_line: string;
    isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein: any;
    applicant_entity_shown_line1_everapplied_for_and_received_an_EIN_if_yes: string;
    designeesName: string;
    designees_Address_ZipCode: string;
    under_penalties_of_perjury_Name_title: string;
    signature: string;
    date: string | null;
    designees_telephone_number: string;
    designees_Fax_Number: string;
    applicants_Telephone_Number: string;
    applicants_Fax_Number: string;
    other_Specify1: string;
    pricipalActivities: string;
    reasonForAppling: string;
    typeofEntity: string;
    under_penalties_of_perjury_Name_titleLid: string | null;
}

export class ParticipantAgreementTemplateBO {
    fmsAct: string;
    cdcsBudgetwithStaffing: number;
    cdcsBudgetwithGoods: number;
    csgBudget: number;
    effectivedate: string | null;
}



export class Individual_Sole_Proprietor_OfAttornyTemplateBO {
    name_of_Appointee: string;
    primary_Appointee_Street_Address_or_PoBox: string;
    primary_Appointee_Apt_or_Suite: string;
    primary_Appointee_Attorney_Number_Accountant_Number_or_Ptin: string;
    primary_Appointee_PhoneNumber: string;
    primary_Appointee_FaxNumber: string;
    primary_Appointee_city: string;
    primary_Appointee_state: string;
    primary_Appointee_Zipcode: string;
    primary_Appointee_EmailAddress: string;
    lLmitedAthourity: string;
    authority_Granted_Type_of_Tax1: string;
    authority_Granted_Type_of_Tax2: string;
    authority_Granted_Type_of_Tax3: string;
    years_of_Periods1: string;
    years_of_Periods2: string;
    years_of_Periods3: string;
    years_of_Periods4: string;
    authority_Experiation_Date: string | null;
    communicate_with_the_department_by_email: boolean;
    sign_returns_and_other_tax_forms: boolean;
    extend_statute_of_limitations_to_assess_tax: boolean;
    excute_Agreements: boolean;
    add_additional_appointees: boolean;
    receive_all_mail_except_refunds: boolean;
    act_on_my_behalf_i_became_incapacitated_or_incompetent: boolean;
    authorize_the_department_to_release_return_information_third_parties: boolean;
    address_If_Different_from_Taxpayer: string;
    print_Name_and_If_applicable: string;
    chooseTitleLid: string | null;
    signPhoneNumber: string;
    signature_City: string;
    signature_State: string;
    signature_Zipcode: string;
    additional_appointee_Form1_Name_of_Taxpayer: string;
    additional_appointee_Form1_SsN_Itin_Mn_Id_or_Fein: string;
    additional_appointeeAddress: Additional_AppointeeAddressTemplateBO[] = [];
}

export class Additional_AppointeeAddressTemplateBO {
    nameofAppointee: string;
    street_Address_or_PoBox: string;
    apt_or_Suite: string;
    attorneyNumber_AccountantNumber_or_Ptin: string;
    phoneNumber: string;
    faxNumber: string;
    city: string;
    zip: string;
    state: string;
    email: string;
}

export class prepopulate {
    adminstrartor: string;
    mail: string;
    city: string;
    agentname: string;
    address: string;
    agentcity: string;
    state: string;
    zip: string;

}
export class functionpermission {

}
